import React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { Profile } from '../../CelsiusQuizApp';

import * as style from './QuizTemplateStyles.module.scss'
import * as elements from '@appStyles/_elements.module.scss';

type Props = {
  profile: Profile;
  closeModal: () => void;
  onSubmit: (data: object) => void;
};

export const QuizTemplate = ({ profile, closeModal, onSubmit }: Props) => {

  const formik = useFormik<{ [index: string]: string }>({
    initialValues: { question_1: '', question_2: '', question_3: '' },
    onSubmit: (values) => {
      closeModal();
      onSubmit(values);
    },
  });

  const setAnswer = (e: any) => { formik.setFieldValue(e.target.name, e.target.value); };

  return (
    <form className={style.root} onSubmit={formik.handleSubmit} >
      <p className={style.title}>Celsius Quiz</p>
      <div>
        <span>If you participate in this loan pitch using your Claim, what happens to your funds?</span>
        <div>
          <label>
            <input className={style.radio} type="radio" name="question_1" value="depositing" onChange={setAnswer}/>
            You are depositing the funds
          </label>
        </div>
        <div>
          <label>
            <input className={style.radio} type="radio" name="question_1" value="lending" onChange={setAnswer}/>
            You are lending the funds
          </label>
        </div>
      </div>
      <div>
        <span>When you lend your cryptocurrency, what happens to it?</span>
        <div>
          <label>
            <input className={style.radio} type="radio" name="question_2" value="held" onChange={setAnswer}/>
            It is held in an account to receive interest
          </label>
        </div>
        <div>
          <label>
            <input className={style.radio} type="radio" name="question_2" value="invested" onChange={setAnswer}/>
            The funds are invested in order to try to generate a return
          </label>
        </div>
      </div>
      <div>
        <span>If I lend to a company that goes bankrupt, what would happen?</span>
        <div>
          <label>
            <input className={style.radio} type="radio" name="question_3" value="creditor" onChange={setAnswer}/>
            Generally you would be a unsecured creditor in a bankruptcy proceeding
          </label>
        </div>
        <div>
          <label>
            <input className={style.radio} type="radio" name="question_3" value="interest" onChange={setAnswer}/>
            You will receive your money back with interest
          </label>
        </div>
        <div>
          <label>
            <input className={style.radio} type="radio" name="question_3" value="nothing" onChange={setAnswer}/>
            Nothing happens
          </label>
        </div>
      </div>
      <div className={style.actionWrapper}>
        <button
          type="button"
          className={`${elements.btn} ${style.cancelBtn}`}
          onClick={closeModal}
        >
          Cancel
        </button>
        <button
          type="submit"
          className={`${elements.btn} ${elements.btnSuccess} `}
        >
          Complete
        </button>
      </div>

    </form>
  );
};
